module.exports = "<div class=\"hp-inner-center project-approved-walkthrough\">\n    <h1>This project has been approved and payment is scheduled for {{appDetail.fundingRequest.FundingRequestDetail.ScheduledDisbursementDate | date: 'EEEE, MMMM d'}}.</h1>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/walkthrough/getPaid/projectApprovedWalkthroughTemplate.html
// module id = 658
// module chunks = 1